<template>
	<div v-if="$route.meta.keepAlive">
		<div v-if="$store.state.LANDUI == 'true'" class="leftNav" :class="$store.state.foldStatus == 'true' ? 'fold-sidebar' : ''">
			<div :class="$store.state.sidebarStatus == 'true' ? 'hide-sidebar' : ''">
				<topHeader :msg-num="msgNum" :msg-List="msgList"></topHeader>
				<leftNav></leftNav>
				<div class="right-main">
					<div class="ld-panel">
						<router-view></router-view>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="leftMenu">
			<leftMenu></leftMenu>
			<div class="ld-panel">
				<router-view></router-view>
			</div>
		</div>
	</div>
	<div v-else>
		<router-view></router-view>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted } from 'vue';
	import { webMsg } from '@/api/home';
	import { topHeader,leftNav } from 'landui-ui'
	import leftMenu from './components/leftMenu.vue'
	
	const msgNum = ref(0);
	const msgList = ref();
	
	const webMsgF = () => {
		webMsg().then((res) => {
			msgNum.value = res.data.message_num;
			msgList.value = res.data.webMsgs
		})
	}
	
	onMounted(() => {
		webMsgF()
	});
	
</script>